import { CUSTOM_STATE_STORAGE_KEY } from '@/composables/auth/constants'
import type { CustomState } from '@/composables/auth/types'

export const deserializeCustomState = (state: string): CustomState => {
  return JSON.parse(state) as CustomState
}

const deserializeIfPossible = (state: string | null | undefined) => {
  if (!state) return null
  try {
    return deserializeCustomState(state)
  } catch (err: unknown) {
    console.warn('[Auth] Failed to parse custom state:', err)
    return null
  }
}

export const consumeCustomState = (state?: string | null) => {
  if (typeof window === 'undefined') return null

  const explicitState = deserializeIfPossible(state)
  if (explicitState) {
    sessionStorage.removeItem(CUSTOM_STATE_STORAGE_KEY)
    return explicitState
  }

  const fromStorage = sessionStorage.getItem(CUSTOM_STATE_STORAGE_KEY)
  if (fromStorage) {
    sessionStorage.removeItem(CUSTOM_STATE_STORAGE_KEY)
    const parsedState = deserializeIfPossible(fromStorage)
    if (parsedState) {
      return parsedState
    }
  }

  return null
}

export const serializeCustomState = (customState: CustomState): string => {
  const serialized = JSON.stringify(customState)

  if (typeof window !== 'undefined') {
    sessionStorage.setItem(CUSTOM_STATE_STORAGE_KEY, serialized)
  }

  return serialized
}

